import LocalizedStrings from 'react-localization';

class Strings {
  static COMMON = new LocalizedStrings({
    'en-US': {
      ok: 'OK',
      submit: 'Submit',
      tryAgain: 'Try Again',
      cancel: 'Cancel',
      continue: 'Continue',
      hourShort: 'hr',
      hoursShort: 'hrs',
      minutesShort: 'min',
      lifetime: 'Lifetime',
      totalHours: 'Total Hours',
      totalCost: 'Total Cost',
      update: 'Update',
      perHour: 'per hr',
      today: 'Today',
      yesterday: 'Yesterday',
      updateAvailable: 'Update available for iworkie',
      refreshNow: 'Refresh Now',
    },
  });

  static LOGIN = new LocalizedStrings({
    'en-US': {
      emailHint: 'email',
      passwordHint: 'password',
      logIn: 'Log in',
      forgotPassword: 'Forgot your password?',
      signUp: 'Sign up',
      bySigningUp1: 'By signing up you agree to iworkie’s ',
      bySigningUp2: ' and ',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
  });

  static WELCOME = new LocalizedStrings({
    'en-US': {
      welcome: 'Welcome!',
      welcomeBrief:
        'We’re excited you’ve chosen iworkie. We’d love to get to know you a little first so we can customize your experience.',
      companyNameHint: 'Name Your Company',
      companyLogo: 'Optional Company Logo',
      go: 'Go',
    },
  });

  static SIDE_MENU = new LocalizedStrings({
    'en-US': {
      projects: 'Projects',
      directory: 'Directory',
      settings: 'Settings',
      logOut: 'Log out',
    },
  });

  static ERROR = new LocalizedStrings({
    'en-US': {
      defaultTitle: 'Houston, we have a problem!',
      defaultBody:
        'Something went wrong. Please check your network settings and try again.',
      createUser:
        'We seem to be having issues while creating your account. Please check your network settings and try again.',
      noConnection:
        'We can’t seem to find a network. Please check you network settings and try again.',
      loginValidation: 'Email address or password cannot be empty.',
      loginInvalidEmail: 'The email address entered is invalid.',
      loginUserDisabled: 'The email address entered has been disabled.',
      loginUserNotFound:
        'We cannot find an account associated with the email address entered.',
      loginWrongPassword:
        'The entered password does not match the password associated with the email address.',
      tooManyAttempts:
        'Too many attempts to login. We’ve blocked access for a short while so you can track down those correct credentials. Please try again later.',
      weakPassword:
        'The password entered is too weak. Please enter a new password and try again.',
      emailAlreadyInUse:
        'The email entered already exists as an account owner. Log in or try a different email address to sign up.',
      forgotPasswordEmailEmpty:
        'Email cannot be empty. Please check email and try again.',
      deleteAccount:
        'We had a problem deleting your account. Please try again later.',
      projectNameExists: 'A project with this name already exists.',
      errorCompanyImage:
        'There was a problem uploading the company image. Please try again or choose different image.',
      errorProjectInvite:
        'There was a problem sending invites. Please check your network settings and try again.',
      errorDeleteInvitationTitle: 'Failed to remove invitation',
      errorDeleteInvitation:
        'There was a problem removing the invitation. Please check your network settings and try again.',
      errorRemoveProjectMemberTitle: 'Failed to remove contributor',
      errorRemoveProjectMember:
        'There was a problem removing the contributor. Please check your network settings and try again.',
      genericTitle: 'Oops!',
      genericInternal:
        'An internal error occurred while processing your request.',
      genericBadRequest:
        'The server received an invalid request. Try refreshing the page and try again.',
      genericDefault:
        'Something went wrong. Try refreshing the page and try again.',
      updateCardErrorTitle: 'Failed to update card',
      updateCardError: 'Did you input the wrong credentials?',
      deleteCardErrorTitle: 'Failed to delete card',
      deleteCardError:
        'Something went wrong. Try refreshing the page and try again.',
      paymentFailedErrorTitle: 'Payment failed',
      paymentFailedError:
        'The payment you have attempted has failed. You have not been charged. Please try again and ensure that you enter your credentials correctly and that the payment card is still valid.',
    },
  });

  static PROJECTS = new LocalizedStrings({
    'en-US': {
      projects: 'Projects',
      activity: 'Recent Activity',
      addProject: 'Add project',
      projectsEmptyTitle: 'No Active Projects to Display',
      getStartedTitle: 'Get Started with Projects',
      getStartedBody:
        'Use projects to organize the work you are wanting to track.',
      getStartedStep1:
        '{0} Create a new project by clicking the “Add Project” button in the top right.',
      getStartedStep2: '{0} Name and customize your new project.',
      getStartedStep3:
        '{0} Invite contributors to the project to make it available in their iworkie app.',
      activityEmptyTitle: 'No Activity to Display',
      activityEmptyBody:
        'Once you have projects and employees connected to your account, you will start to see when users are adding or amending time to the projects you have shared with them.',
      failedTitle: 'Failed to fetch projects',
      failedBody: 'Please check your internet connection and try again.',
      activeProjectsHeader:
        'The following projects are currently active. Any users connected to these projects will still see the project in their app and be able to apply time to it.',
      closedProjects: 'Closed Projects',
      closedProjectsHeader:
        "The following projects have been closed. Closed project are no longer visible in connected users' apps. Projects can be reactivated at any time.",
      closedAt: 'Closed: {0} at {1}',
      activityFailedTitle: 'Failed to fetch recent activity',
      activityFailedBody:
        'Please check your internet connection and try again.',
      loggedTimeTo: 'to {0}',
    },
  });

  static NEW_PROJECT = new LocalizedStrings({
    'en-US': {
      colorHoverHint1: 'Hover over the box to find a color.',
      colorHoverHint2: 'Click to lock in your selection.',
      nameHint: 'Name Your Project',
      createProject: 'Create Project',
      saveProject: 'Save Project',
    },
  });

  static PROJECT_DETAILS = new LocalizedStrings({
    'en-US': {
      team: 'Team',
      teamEmptyTitle: 'No Active Team',
      teamEmptyBody:
        'Invite users to log time to this project to build your project team.',
      invite: 'Invite',
      inviteWithPlus: '+ Invite',
      activeEmployees: 'Active Employees',
      teamSection: 'Team:',
      closeProject: 'Close Project',
      closeProjectInfo:
        'The project team will no longer be able to submit hours to this project. Hours and historical information will still be available.',
      projectClosedTitle: 'This project has been closed.',
      projectClosedBody:
        'To allow users to contribute to this project, reopen it and invite them.',
      reopenProject: 'Reopen Project',
      closeProjectDialogTitle: 'Close this project?',
      closeProjectDialogHeader:
        'All connections to team members will be cut and they will no longer be able to add logged time to this project.',
      closeProjectDialogBody:
        'Your project data will remain available and you will still be able to review all the project information.',
      reopenProjectDialogTitle: 'Reopen this project?',
      reopenProjectDialogHeader:
        'You will be able to invite users to submit logged time to this project.',
      reopenProjectDialogBody:
        'Previous connections will not be restored. Past connections will have to be invited again.',
      removeInvitationDialogTitle: 'Cancel Invitation?',
      removeInvitationDialogHeader:
        "By cancelling this invitation, this user's activation link will not work and they will not be able to connect and submit logged hours.",
      removeInvitationDialogBody:
        'If invited again a new activation link will be generated.',
      removeMemberDialogTitle: 'Remove Contributor?',
      removeMemberDialogHeader:
        'Removing this user will disconnect them from the project and you will no longer receive logged hours from them.',
      removeMemberDialogBody:
        'A user can be reconnected by inviting them again.',
      pending: 'Pending',
      pendingInfo:
        'The following users have been invited to this project but have yet to connect.',
      remind: 'remind',
      closedOn: 'This project was closed on {0}',
      perHour: '/hr',
      editMemberDialogTitle: 'Edit billable rate',
      editMemberDialogInfo:
        "Set a custom rate for this employee that will override their default rate. This rate will only be applied to the current project and will be used to calculate project totals for this user's logged time only.",
      editMemberDialogRateTitle: 'Custom project rate',
      restoreDefault: 'Restore Default',
    },
  });

  static DIRECTORY = new LocalizedStrings({
    'en-US': {
      activeTeam: 'Active Team',
      activity: 'Activity',
      noActiveContributors: 'No Active Contributors',
      getStartedTitle: 'Get Started Building Your Team',
      getStartedBody:
        'Your team is built through your active projects. You can easily invite anyone to one or more projects and they will be see your project in their iworkie app, and be able to log time to them. The time they log will then be visible to you in the project common.',
      getStartedStep1:
        '{0} Create or select a project from your projects section.',
      getStartedStep2:
        '{0} Build your project teams from the project details screens on the right hand side.',
      getStartedStep3:
        '{0} Click “Invite” to pick from your active team or email an invite to a new user.',
      inactiveConnections: 'Inactive Connections',
      inactiveConnectionsBody:
        'You currently have no inactive connections. As you add users and their project connections are closed, they will be added to this list for reference.',
      activityEmptyTitle: 'No Activity to Display',
      activityEmptyBody1:
        'Once you start to invite users to your projects, you will be able to see the connections and disconnections as they occur.',
      activityEmptyBody2:
        'To add people to your team, find, or create, the {0} you want them to work on and invite them to it.',
      project: 'project',
      failedTitle: 'Failed to fetch team members',
      failedBody: 'Please check your internet connection and try again.',
      activeTeamMembersHeader:
        'The following contributors are currently connected to active projects.',
      pendingInvites: 'Pending Project Invites',
      inactiveConnectionsInfo:
        'The following users have contributed to projects in the past but currently have no connections or invitations to active projects.',
      connected: 'Connected',
      disconnected: 'Disconnected',
      connectedTo: 'to {0}',
      disconnectedFrom: 'from {0}',
      loadMoreActivity: 'Load More Activity',
    },
  });

  static EMPLOYEE_DETAILS = new LocalizedStrings({
    'en-US': {
      directory: 'Directory',
      projects: 'Projects:',
      activeProjects: 'Active Projects',
      pendingProjects: 'Pending Projects',
      closedProjects: 'Closed Projects',
      iworkieId: 'iworkie ID',
      role: 'Role',
      defaultRate: 'Default Rate',
      rateInfo:
        'Rates can also be set at the project level. Total cost will reflect these custom values.',
    },
  });

  static SETTINGS = new LocalizedStrings({
    'en-US': {
      settings: 'Settings',
      save: 'Save',
      accountInformation: 'Account Information',
      planAndBilling: 'Plan & Billing',
      support: 'Support',
      contactUs: 'Contact Us',
      contactUsInfo:
        'If you’d like to contact us directly about specific issues, feedback or requests, we are always happy to connect at ',
      contactUsEmail: 'support@iworkie.com',
      versionNumber: 'Version',
    },
  });

  static ACCOUNT_INFORMATION = new LocalizedStrings({
    'en-US': {
      addCompanyLogo: 'Add company logo',
      defaultCurrency: 'Default Currency',
      securitySettings: 'System Settings',
      email: 'Email',
      deleteAccount: 'Delete Account',
      deleteAccountPromptTitle: 'Delete Your Account?',
      deleteAccountPromptBody1:
        'This will remove any shared projects and all data collected to date. If you are on paid service, you will be charged for current active month.',
      deleteAccountPromptBody2:
        'Type your password here to delete your account.',
      companyName: 'Company name',
      emailAndUsername: 'Your email/username is:  ',
      currentPlan: 'Current Plan:',
      upgrade: 'Upgrade',
    },
  });

  static BILLING = new LocalizedStrings({
    'en-US': {
      currentPlan: 'Current Plan',
      planBasic: 'Basic (Free)',
      upgradeToPremium: 'Upgrade to premium',
      premium: 'Premium',
      downgrade: 'Downgrade',
      nextBillingDate: 'Next Billing Date',
      NA: 'N/A',
      currentUsage: 'Current Usage',
      currentUsageInfo:
        'The breakdown of users and projects with the resulting cost for the current billing month so far',
      connectedUsers: 'Connected Users',
      projects: 'Projects',
      costThisMonth: 'Cost this month',
      billingInformation: 'Billing Information',
      addCard: 'Add Card',
      billingEmail: 'Billing Email',
      expiration: 'Expiration',
      paymentHistory: 'Payment History',
      paymentHistoryEmpty:
        'Payment history will display following first payment',
      modalTitle: 'Upgrade To Premium Today!',
      modalProjectsTitle: 'Unlimited Projects',
      modalProjectsBody:
        'Track as many projects as you want. Keep all project data as long as you need it with no need to delete project info to make way for new projects.',
      modalContributorsTitle: 'Unlimited Contributors',
      modalContributorsTitleInfo: '+ $2/month per extra user over 10',
      modalContributorsBody:
        'Enjoy a deeper understanding of your company productivity and project progress by inviting your entire team, with no restrictions on numbers.',
      maybeLater: 'Maybe Later',
      upgradeNow: 'Upgrade Now',
      date: 'Date',
      paymentMethod: 'Payment Method',
      amount: 'Amount',
      status: 'Status',
      receipt: 'Receipt',
      download: 'Download',
      planError: 'Error Fetching Plan',
      upcomingInvoiceError: 'Error Fetching Date',
      paymentCardError: 'Error Fetching Billing Information',
      paymentHistoryError: 'Error Fetching Payment History',
      refresh: 'Refresh',
      downgradeTitle: 'Downgrade your account?',
      downgradeWarning:
        'This will delete information for any projects created after your initial 3 free projects, and delete information collected from any connected employees active after your initial 3 connections.',
      downgradeWarningDetail:
        'Your service will be downgraded at the end of the current active month where these changes will take effect. You can reverse this decision up until that date.',
      deleteCardTitle: 'Delete Stored Card Info?',
      deleteCardWarning:
        'You must have a connected card in order to make any payments automatically',
      deleteCardWarningDetail:
        'Failure to add a payment option may result in a downgrading of your account and limit access to information. To change payment info, please edit an existing card.',
      cancel: 'Cancel',
      continue: 'Continue',
      cardNumber: 'Card Number',
      CVC: 'CVC',
      updateCard: 'Update Card',
      deleteCard: 'Delete Card',
      cardExpiring1: 'Credit Card Expiring!',
      cardExpiring2: 'Your stored card will expire before the next payment.',
      cardExpiring3:
        'Update your billing information to ensure uninterrupted service.',
      failedPayment1: 'Payment Failed! Your payment scheduled for',
      failedPayment2:
        'failed. Please check and update your payment information.',
      noCard:
        'You have deleted your billing information. Add a card to ensure that your next invoice can be paid.',
      restoreSubscription: 'Restore Subscription',
      planActiveCanceled: 'Premium (Canceled)',
      retry: 'Retry Payment',
      endSubscription: 'End Subscription',
      successfullyDeleted:
        'You must add a new payment method to continue using any premium features. Failure to do so will result in a downgrading of your account',
      success: 'SUCCESS',
      successful: 'Successful!',
      successfulPremium: 'Premium Upgrade Successful',
      successfulPremiumTitle:
        'Enjoy unlimited projects and invite all all your employees to connect with no restrictions',
      successfulPremiumText:
        'Start inviting your employees to projects to start seeing their time flow in and get a better picture of your companies productivity.',
      successfulRestoration:
        'Your premium has been re-enabled and your service will continue uninterrupted',
      successfullyCanceled: 'Your subscription has been canceled!',
      successfullyEnded: 'Your subscription has ended!',
      successfullyRemoved: 'Your card information was successfully removed.',
      paymentUpdated: 'Default payment updated',
      paymentUpdatedText:
        'This payment method can be edited or removed at any time in the settings.',
      popUpInfoConnectedMembers:
        'Any connected app user with an active connection to any active project.',
      premiumSuccessDialogBody:
        'Start inviting your employees to projects to start seeing their time flow in and get a better picture of your companies productivity',
    },
  });

  static PAGE_NOT_FOUND = new LocalizedStrings({
    'en-US': {
      title: 'Page Not Found',
      header: 'The page you are trying to access cannot be found',
      body1:
        'This can occur if the page no longer exists due to project information being deleted.',
      body2:
        'If you think you have landed here in error, please check your entered url.',
      return: '› Return Home',
    },
  });

  static INVITE = new LocalizedStrings({
    'en-US': {
      share: 'Share:',
      emailHint: 'email address',
      notesHint: 'Add a note',
      sendInvites: 'Send Invites',
      inviteTeamMembers: 'Invite Team Members',
      selectAll: 'Select All',
      add: 'Add',
    },
  });

  static CURRENCIES = new LocalizedStrings({
    'en-US': {
      dollar: '$ Dollar',
      dollarCode: 'USD',
      euro: '€ Euro',
      euroCode: 'EUR',
      yen: '¥ Yen',
      yenCode: 'JPY',
      pound: '£ Pound',
      poundCode: 'GBP',
      ruble: '₽ Ruble',
      rubleCode: 'RUB',
      rupee: '₹ Rupee',
      rupeeCode: 'INR',
      rial: '﷼ Rial',
      rialCode: 'IRR',
    },
  });

  static EXPORT = new LocalizedStrings({
    'en-US': {
      date: 'Date',
      project: 'Project',
      employee: 'Employee',
      hours: 'Hours',
      rawHours: 'Raw Hours',
      hourlyRate: 'Hourly rate',
      cost: 'Cost',
      currency: 'Currency',
      notes: 'Notes',
      total: 'Total',
    },
  });
}

export default Strings;



// WEBPACK FOOTER //
// ./src/common/Strings.js